<template>
  <v-container fluid>
    <v-card style="max-width: 100% !important;margin: 0 auto !important;box-shadow:none !important;" class="pa-0 ma-0 pt-6 text-center">
      <v-card-title class="titlesWP1 justify-center">
        {{ parseAttribute('lubricantdealer') }}
      </v-card-title>
      <v-card-text class="pt-0">
        <div class="row text-center pt-2 mt-2">
          <div class="col-md-12 col-sm-12 col-xs-12 titlesWP3" v-for="(item,i) in pagedata" :key="i">
            <v-toolbar-title class="ma-0 pa-0">
              <v-btn style="font-size: 1rem;border-radius: 15px 0;color: #ffffffb3; background: rgb(42 54 134);" class="font-weight-bold px-6 py-4">
                {{ parseAttribute('region'+i) }}
              </v-btn>
            </v-toolbar-title>
              <div class="row text-center pt-2">
                <div class="col-md-12 col-sm-12 col-xs-12 titlesWP3 text-start" v-for="(item2,ii) in item" :key="ii">
                  <template v-for="(item22,ii2) in item2">
                    <v-toolbar-title v-if="!AppIsMobile" class="ma-0 pa-0 mx-2 mt-2">
                      <v-btn :class="activeClasses" style="font-size: 1rem;width:25%;border-radius: 15px 0;" class="justify-content-center font-weight-bold px-6 py-4 myred white--text darken-3">
                        {{ ii2 }}
                      </v-btn>
                    </v-toolbar-title>
                    <v-toolbar-title v-if="AppIsMobile" class="ma-0 pa-0 mx-2 mt-2">
                      <v-btn :class="activeClasses" style="font-size: 1rem;width:auto;border-radius: 15px 0;" class="justify-content-center font-weight-bold px-6 py-4 myred white--text darken-3">
                        {{ ii2 }}
                      </v-btn>
                    </v-toolbar-title>
                    <div class="row text-center pt-2">
                      <div v-if="AppIsMobile" class="justify-center col-md-4 col-sm-12 mt-2 col-xs-12" style="border-radius: 15px;background-size:98%;background: #1F235D22; color: #071365 !important; font-size: 15px !important;" v-for="(item3,iii) in item22" :key="iii+`a`">
                        {{item3.text}}
                        <v-card-text v-if="item3.contact_number!==0" class="pa-0">
                          0{{item3.contact_number}}
                        </v-card-text>
                        <v-btn target="_blank" :href="`https://maps.app.goo.gl/`+item3.map_url" class="titlesWP3 me-3" width="40%" height="40" :style="`background-color:transparent;background-image: url('build/images/maps.png'); font-size: 15px !important; color: #071365 !important;background-repeat: no-repeat;background-size: 38px 38px; box-shadow: none; background-position: `+AppOpositeAlign+`;`" :class="`app-dt-btn float-`+AppOpositeAlign" small>
                          {{parseAttribute('location')}}
                        </v-btn>
<!--                        <v-btn width="40" height="40" :class="`app-dt-btn float-`+AppAlign" fab small>-->
<!--                          <v-icon style="color: #071365 !important;">mdi-bank</v-icon>-->
<!--                        </v-btn>-->
                        <v-btn v-if="item3.icon===1" width="40" height="40" :class="`app-dt-btn float-`+AppAlign" :style="`background-color:transparent;`" fab small>
                          <v-icon style="color: #071365 !important;">mdi-bank</v-icon>
                        </v-btn>
                        <v-btn v-if="item3.icon===2" width="40" height="40" :class="`app-dt-btn float-`+AppAlign" :style="`background-color:transparent;`" fab small>
                          <v-icon style="color: #071365 !important;">mdi-progress-wrench</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="!AppIsMobile" class="justify-center col-md-4 col-sm-12 mt-2 col-xs-12 py-0" style="border-radius: 15px;background-size:98%;color: #071365 !important;" v-for="(item3,iii) in item22" :key="iii+`a`">
                        <app-col cols="12" style="padding-bottom:4px !important;border-radius: 15px;color: #071365 !important;background: #1F235D22;">
                          <app-col class="ma-0 pa-0" cols="12" style="color: #071365 !important;">
                            <app-row justify="center" class="ma-0 pa-0" style="color: #071365 !important;width:100% !important;height:100% !important;">
                              {{item3.text}}
                              <span v-if="item3.contact_number!==0" class="pa-0">
                                &nbsp;- 0{{item3.contact_number}}
                              </span>
                            </app-row>
                          </app-col>
                          <app-row justify="center" class="ma-0 pa-0" style="color: #071365 !important;width:100% !important;height:100% !important;">
                            <app-col class="ma-0 pa-0" cols="4" style="color: #071365 !important;">
                            <v-btn v-if="item3.icon===1" width="40" height="40" :class="`app-dt-btn float-`+AppAlign" :style="`background-color:transparent;`" fab small>
                              <v-icon style="color: #071365 !important;">mdi-bank</v-icon>
                            </v-btn>
                            <v-btn v-if="item3.icon===2" width="40" height="40" :class="`app-dt-btn float-`+AppAlign" :style="`background-color:transparent;`" fab small>
                              <v-icon style="color: #071365 !important;">mdi-progress-wrench</v-icon>
                            </v-btn>
                            </app-col>
                            <app-col class="ma-0 pa-0" cols="4" style="color: #071365 !important;"></app-col>
                            <app-col class="ma-0 pa-0" cols="4" style="color: #071365 !important;">
                            <v-btn target="_blank" :href="`https://maps.app.goo.gl/`+item3.map_url" class="titlesWP3 me-3 justify-end" width="100%" height="40" :style="`background-color:transparent;background-image: url('build/images/maps.png'); font-size: 15px !important; color: #071365 !important;background-repeat: no-repeat;background-size: 38px 38px; box-shadow: none; background-position: `+AppOpositeAlign+`;`" :class="`app-dt-btn float-`+AppAlign" small>
                              {{parseAttribute('location')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </v-btn>
                            </app-col>
                          </app-row>
                        </app-col>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style>
.titlesWP1{
  font-family: "Janna LT Regular",sans-serif !important;
  color: #071365 !important;
  font-size: 55px !important;
  font-weight: 600 !important;
}
.titlesWP2{
  color: #6A6A6F !important;
  font-family: "Janna LT Regular",sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: 500 !important;
  line-height: 1.5em !important;
}
.titlesWP3{
  font-family: "Janna LT Regular",sans-serif !important;
  color: #BF0100 !important;
  font-size: 20px !important;
  font-weight: 600 !important;
}
.panel-active {
  font-family: "Janna LT Regular",sans-serif !important;
  color: #071365 !important;
  font-size: 20px !important;
  font-weight: 600 !important;
}
@media (max-width: 767px){
  .v-breadcrumbs li a {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-breadcrumbs li a:hover {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-breadcrumbs__divider {
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: bolder !important;
  }
  .titlesWP1{
    font-size: 45px !important;
  }
  .titlesWP2{
    font-size: 15px !important;
  }
}
@media (max-width: 575.98px) {
  .titlesWP1{
    font-size: 45px !important;
  }
  .titlesWP2{
    font-size: 15px !important;
  }
  .v-breadcrumbs li a {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-breadcrumbs li a:hover {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-breadcrumbs__divider {
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: bolder !important;
  }
}
</style>
<script>

import MetaInfoMixin from '@mixins/MetaInfoMixin';
export default {
  name: 'dealer',
  mixins: [MetaInfoMixin],
  data() {
    return {
      pagedata: null
    };
  },
  methods:{
    getdealers(){
      this.$axios.post(`getdealers`, {
        params: {
          page: 'dealer',
        }}).then(data => {
        this.pagedata = data.data.data;
      }).catch(({response}) => {
        console.log(response);
      });
    },
    activeClasses() {
      return [
        'active-item',
        'myred',
        'white--text',
        'darken-3',
      ].join(' ');
    },
    activeFontSize(){
      return "font-size:"+!this.AppIsMobile?"32px;":"20px;";
    },
    getMarginBySize(){
      return "margin-"+this.AppOpositeAlign+": 1px !important;"
    }
  },
  mounted() {
    this.getdealers();
  }
};
</script>
